<section aria-labelledby="payment-details-heading">
  <div class="shadow sm:rounded-md sm:overflow-hidden">
    <div class="bg-surface py-6 px-4 sm:p-6">
      <div>
        <div class="flex items-center gap-2">
          <h2 id="payment-details-heading" class="text-lg leading-6 font-medium text-fg-primary">
            {{ heading }}
          </h2>
          @if (disabled) {
            <app-ng-icon name="heroLockClosed" [tp]="'Für Änderungen fehlt dir die Berechtigung'">
            </app-ng-icon>
          }
        </div>
        @if (description) {
          <p class="mt-1 text-sm text-fg-secondary">
            {{ description }}
          </p>
        }
      </div>

      <ng-content></ng-content>
    </div>
    @if (showFooter) {
      <div class="px-4 py-3 bg-surface text-right sm:px-6">
        @if (showSaveButton) {
          <button
            type="button"
            [attr.disabled]="disabled ? '' : null"
            (click)="prepareSave()"
            class="relative bg-gray-800 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-900 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Speichern
            @if (isSaving) {
              <p class="absolute left-0 -ml-24 text-green-600">Gespeichert</p>
            }
          </button>
        }
      </div>
    }
  </div>
</section>
